import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, TransitionGroup as _TransitionGroup, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-75b218bf")

_pushScopeId("data-v-75b218bf")
const _hoisted_1 = {
  key: 0,
  class: "no-redirect"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")

  return (_openBlock(), _createBlock(_component_el_breadcrumb, {
    class: "app-breadcrumb",
    "separator-class": "el-icon-arrow-right"
  }, {
    default: _withId(() => [
      _createVNode(_TransitionGroup, { name: "breadcrumb" }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.breadcrumbs, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
              key: item.path
            }, {
              default: _withId(() => [
                (item.redirect === 'noredirect' || index === _ctx.breadcrumbs.length-1)
                  ? (_openBlock(), _createBlock("span", _hoisted_1, _toDisplayString(_ctx.t('route.' + item.meta.title)), 1))
                  : (_openBlock(), _createBlock("a", {
                      key: 1,
                      onClick: _withModifiers(($event: any) => (_ctx.handleLink(item)), ["prevent"])
                    }, _toDisplayString(_ctx.t('route.' + item.meta.title)), 9, ["onClick"]))
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})